var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.labels),function(label){return [_c('span',{style:(("fill: " + (_vm.scale(label))))},[_vm._v(_vm._s(label))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }